import { render, staticRenderFns } from "./TwitchPlayer.vue?vue&type=template&id=48baae57&"
import script from "./TwitchPlayer.vue?vue&type=script&lang=js&"
export * from "./TwitchPlayer.vue?vue&type=script&lang=js&"
import style0 from "./TwitchPlayer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports